import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Консультація',
  description: 'Аналіз ситуації та визначення можливих шляхів вирішення.'
}, {
  title: 'Аудит',
  description: 'Вивчення документів та оцінка судових перспектив.'
}, {
  title: 'Стратегія',
  description: 'Формування плану дій та підготовка документації.'
}, {
  title: 'Захист',
  description: 'Представництво в судах до досягнення результату.'
}];
export function Process() {
  return <section className="py-24 px-6 bg-white border-t border-zinc-100" data-id="element-71">
      <div className="max-w-6xl mx-auto" data-id="element-72">
        <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-zinc-900 mb-16 md:mb-24 text-center" data-id="element-73">
          Як ми працюємо
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6" data-id="element-74">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-75">
              <div className="text-6xl font-light text-zinc-100 mb-6 tracking-tighter" data-id="element-76">
                0{index + 1}
              </div>
              <h3 className="text-lg font-medium text-zinc-900 mb-3" data-id="element-77">
                {step.title}
              </h3>
              <p className="text-zinc-500 text-sm leading-relaxed font-light max-w-[200px]" data-id="element-78">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}